import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { AuthorizationPipe } from '../../../common/pipes/authorization.pipe';
import { DepartmentService } from '../../services/department.service';
import { UserRolePermissions } from './../../models/user-role-permission';

@Component({
    selector: 'department-user-view',
    templateUrl: '../../templates/template1/views/department/department-user-view.component.html',
    styleUrls: ['../../templates/template1/themes/default/css/department.less'],
    providers: [AuthorizationPipe]
})
export class DepartmentUserViewComponent implements OnInit {
  departmentId: Number;
    departmentName = '';
    userId: Number;
    user: UserRolePermissions ;

   constructor(
      private router: Router,
        private _departmentService: DepartmentService, private activatedRoute: ActivatedRoute
       ) {
       this.departmentId = +activatedRoute.snapshot.params['departmentId'];
       this.userId  =  +activatedRoute.snapshot.params['userId'];
        this.activatedRoute.fragment.subscribe((fragment: string) => {
          this.departmentName = fragment;
       });
    }

  ngOnInit(): void {
     this.activatedRoute.fragment.subscribe((fragment: string) => {
        this.departmentName = fragment;
    });
     this._departmentService.getUserById(this.departmentId,this.userId).subscribe((response:any) => {      
           this.user = response;
    }) ;
  }

     backToDepartmentUsers() {
      this.router.navigate(['/customerservice/department', this.departmentId, 'users'], { fragment: this.departmentName });
    }
}



// WEBPACK FOOTER //
// ./src/app/customerservice/components/department/department-user-view.component.ts